var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 6.69593L8.56481 10.2607L10 8.82556L6.43519 5.26074L10 1.69593L8.56482 0.260742L5 3.82556L1.43519 0.260742L-2.28713e-07 1.69593L3.56481 5.26074L-1.3649e-06 8.82556L1.43518 10.2607L5 6.69593Z","fill":"black"}));
}

Cross.defaultProps = {"width":"10","height":"11","viewBox":"0 0 10 11","fill":"none"};

module.exports = Cross;

Cross.default = Cross;
